import React, { useState,  useEffect } from 'react';
import { Axios } from '../utils/UtilityFunctions'


import { ListItem, ListItemText } from '@material-ui/core'




export default function UploadeFileLine({ file }) {

    const [uploadStatus, setUploadStatus] = useState('loading');

    useEffect(() => { 
       const myAsyncFunc = async () => {
            const formData = new FormData();
            formData.append(`uploadfile`, file);

            const headers = {
                'content-type': 'multipart/form-data'
            }

            const uploadedQuotes = await Axios('POST', '/quote/uploadFiles', formData, headers);

            console.log('uploadedQuotes', uploadedQuotes)
            setUploadStatus(uploadedQuotes.data.uploadStatus ? 'Complete' : 'Failed')
        }

        myAsyncFunc()
        return () => {  };
    }, [file]);



    return (
        <ListItem color="primary"  >
            <ListItemText color="primary" primary={file.name} />
            <ListItemText primary={<>{uploadStatus}</>} />
        </ListItem>
    )

}